import { Button, Flex, Text } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { UpdateCustomerBlock } from "../../components/CustomerBlock/UpdateCustomerBlock/UpdateCustomerBlock";
import { Layout } from "../../components/Layout/Layout";
import { RootState, useAppDispatch, useAppSelector } from "../../store";
import { useFormik } from "formik";
import { useEffect } from "react";
import { fetchUpdateCustomer } from "../../store/slices/customers";
import PageLoaderWrapper from "../../components/PageLoaderWrapper";
import { CustomerForm } from "../../model/customers";

export const UpdateCustomerPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { currentCustomer, isLoading } = useAppSelector((state: RootState) => state.customers);

  const formik = useFormik<CustomerForm>({
    initialValues: {
      name: "",
      inn: "",
      description: "",
      business_area_id: null,
      responsible_user_id: null,
      comments: "",
    },
    onSubmit: () => {},
  });

  useEffect(() => {
    if (currentCustomer) {
      formik.setFieldValue("name", currentCustomer.name ?? "");
      formik.setFieldValue("business_area_id", currentCustomer.business_area ? currentCustomer.business_area.id : null);
      formik.setFieldValue("responsible_user_id", currentCustomer?.responsible_user?.id ?? null);
      formik.setFieldValue("comments", currentCustomer.comments ?? "");
      formik.setFieldValue("inn", currentCustomer.inn ?? "");
      formik.setFieldValue("description", currentCustomer.description ?? "");
    }
  }, [currentCustomer]);

  // Проверяем, были ли внесены изменения
  const hasChanges =
    currentCustomer &&
    (formik.values.name !== (currentCustomer.name ?? "") ||
      formik.values.business_area_id !== (currentCustomer.business_area ? currentCustomer.business_area.id : null) ||
      formik.values.responsible_user_id !== (currentCustomer?.responsible_user?.id ?? null) ||
      formik.values.comments !== (currentCustomer.comments ?? "") ||
      formik.values.inn !== (currentCustomer.inn ?? "") ||
      formik.values.description !== (currentCustomer.description ?? ""));

  return (
    <Layout>
      <PageLoaderWrapper isLoading={isLoading} loadingText="Загрузка данных заказчика для редактирования...">
        <Flex flexDirection="column" gap="24px" paddingRight="32px" maxH="90vh" overflowY="auto">
          <Text
            color="gray.500"
            cursor="pointer"
            onClick={() => navigate(`/customers/${currentCustomer?.id}`)}
            display="flex"
            alignItems="center"
            gap="8px"
          >
            <ArrowBackIcon />К заказчику
          </Text>
          <Flex flexDirection="column" gap="4px">
            <Text fontSize={30} lineHeight="36px" fontWeight={700} color="#3b515e">
              Редактирование заказчика
            </Text>
            <Text fontSize={16} lineHeight="24px" fontWeight={400} color="#65758b">
              Обновите информацию о заказчике
            </Text>
          </Flex>
          <UpdateCustomerBlock formik={formik} />
          <Flex gap="16px" justifyContent="flex-end">
            <Button onClick={() => navigate(-1)}>Отмена</Button>
            <Button
              bg="#2563eb"
              color="white"
              _hover={{ bg: "#2563eb" }}
              _active={{ bg: "#2563eb" }}
              onClick={() => {
                dispatch(fetchUpdateCustomer({ id: Number(currentCustomer?.id), params: formik.values })).then((res: any) => {
                  if (res.payload.id) {
                    currentCustomer && navigate(`/customers/${currentCustomer.id}`);
                  }
                });
              }}
              isDisabled={
                formik.values.name === "" ||
                formik.values.responsible_user_id === null ||
                formik.values.business_area_id === null ||
                formik.values.inn === "" ||
                !hasChanges
              }
            >
              Сохранить
            </Button>
          </Flex>
        </Flex>
      </PageLoaderWrapper>
    </Layout>
  );
};
